import {Component, OnInit} from '@angular/core';
import {
  AppUserPartnerWalletAccess,
  ThirdPartyCompany,
  ThirdPartyCompanyPerson
} from '../../../dto/app-user-partner-wallet-access-slim';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {IdentStatus} from '../../../dto/ident-status';
import {Upload} from '../../../dto/upload';
import {PartnerWalletService} from '../../../partner-wallet.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastService} from 'angular-toastify';
import {DatePipe} from '@angular/common';
import {CustomersService} from '../../services/customers.service';
import {MatDialog} from '@angular/material/dialog';
import {FileHelper} from '../../../helpers/file-helper';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-pending-invite-detail',
  templateUrl: './pending-invite-detail.component.html',
  styleUrls: ['./pending-invite-detail.component.css']
})
export class PendingInviteDetailComponent implements OnInit {

  inviteId: number;
  public invite: AppUserPartnerWalletAccess|null;
  public isLoading = false;

  public identStatus = IdentStatus;

  urlSafe: SafeResourceUrl;
  isFrameHidden = true;
  isImgHidden = true;
  filename = null;
  errorMsg = null;

  fieldsThirdPartyCompany = [
    { header: 'Company name', cell: (row: ThirdPartyCompany) => `${row.name}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'Address', cell: (row: ThirdPartyCompany) => `${row.address}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'Building', cell: (row: ThirdPartyCompany) => `${row.buildingNumber}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'Post code', cell: (row: ThirdPartyCompany) => `${row.postCode}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'City', cell: (row: ThirdPartyCompany) => `${row.city}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'Country', cell: (row: ThirdPartyCompany) => `${row.country.name}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'Reg. No.', cell: (row: ThirdPartyCompany) => `${row.regNo}` } as ContentRowField<ThirdPartyCompany>,
    { header: 'VAT ID', cell: (row: ThirdPartyCompany) => `${row.vatNo}` } as ContentRowField<ThirdPartyCompany>,

  ];

  fieldsApplicant = [
    { header: 'DOB', cell: (row: ThirdPartyCompanyPerson) => this.datePipe.transform(row.dob, 'dd.MM.yyyy') } as ContentRowField<ThirdPartyCompanyPerson>,
    { header: 'Nationality', cell: (row: ThirdPartyCompanyPerson) => `${row.nationality}` } as ContentRowField<ThirdPartyCompanyPerson>,
    { header: 'Role', cell: (row: ThirdPartyCompanyPerson) => {
        if ( row.role === 1 ) {
 return 'Director'; 
}
        if ( row.role === 2 ) {
 return 'Shareholder'; 
}
        return '-';
      } } as ContentRowField<ThirdPartyCompanyPerson>,
    { header: 'Share %', cell: (row: ThirdPartyCompanyPerson) => `${row.sharePercent}` } as ContentRowField<ThirdPartyCompanyPerson>,
  ];

  fieldsIdent = [
    { header: 'Status', icon: (row: AppUserPartnerWalletAccess) => 'beenhere', iconColor: (row: AppUserPartnerWalletAccess) => {
        if ( row.identStatus === IdentStatus.success) {
return 'green';
}
        if ( row.identStatus === IdentStatus.pending) {
return 'orange';
}
        if ( row.identStatus === IdentStatus.fail) {
return 'red';
}
        if ( row.identStatus === IdentStatus.abandoned) {
return 'red';
}
        if ( row.identStatus === IdentStatus.expired) {
return 'red';
}
        return 'black';
      }, cell: (row: AppUserPartnerWalletAccess) => {
        if ( row.identStatus === IdentStatus.success) {
return 'Success';
}
        if ( row.identStatus === IdentStatus.pending) {
return 'Pending';
}
        if ( row.identStatus === IdentStatus.fail) {
return 'Failed';
}
        if ( row.identStatus === IdentStatus.abandoned) {
return 'Abandoned';
}
        if ( row.identStatus === IdentStatus.expired) {
return 'Expired';
}
        return 'unknown';
      } } as ContentRowField<AppUserPartnerWalletAccess>,
    { header: 'Document', cell: (row: AppUserPartnerWalletAccess) => `${row.identDocumentType || ''} ${row.identDocumentNumber || ''}` } as ContentRowField<AppUserPartnerWalletAccess>,
    { header: 'Valid until', cell: (row: AppUserPartnerWalletAccess) => row.identDocumentValidUntil?this.datePipe.transform(row.identDocumentValidUntil, 'dd.MM.yyyy'): '-' } as ContentRowField<AppUserPartnerWalletAccess>,
    { header: 'Name', cell: (row: AppUserPartnerWalletAccess) => `${row.identDataFirstName} ${row.identDataLastName}` } as ContentRowField<AppUserPartnerWalletAccess>,
    { header: 'DOB', cell: (row: AppUserPartnerWalletAccess) => row.identDataDob?this.datePipe.transform(row.identDataDob, 'dd.MM.yyyy'): '-' } as ContentRowField<AppUserPartnerWalletAccess>,

  ];

  fieldsPerson = [
    { header: 'Role', cell: (row: ThirdPartyCompanyPerson) => {
        if ( row.role === 1 ) {
 return 'Director'; 
}
        if ( row.role === 2 ) {
 return 'Shareholder'; 
}
        return '-';
      } } as ContentRowField<ThirdPartyCompanyPerson>,
    { header: 'Share %', cell: (row: ThirdPartyCompanyPerson) => `${row.sharePercent}` } as ContentRowField<ThirdPartyCompanyPerson>,
  ];
  files: Upload[] = [];

  constructor(
    private partnerWalletService: PartnerWalletService,
    private route: ActivatedRoute,
    private _toastService: ToastService,
    private datePipe: DatePipe,
    private customersService: CustomersService,
    public sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  goBack() {
    this.router.navigate(['..'], { relativeTo: this.route });
  }

  private loadData() {
    this.isLoading = true;
    this.inviteId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.partnerWalletService.getInvite(this.inviteId).subscribe(invite => {
      this.invite = invite;
      if ( invite.thirdPartyCompany ) {
        this.files.push(invite.thirdPartyCompany.registrationDocument);
        this.files.push(invite.thirdPartyCompany.companyAgreementDocument);
      }

      this.isLoading = false;
    }, err => {
      this._toastService.error(err.error);
      this.isLoading = false;
    });

  }


  downloadFile(fileId: number) {
    this.customersService.getFile(fileId).subscribe(
      result => {
        FileHelper.saveFile(result);
      },
      err =>
        this._toastService.error(err.error.message || err.message || err.error || err)
    );
  }

  openFile(fileId: number) {
    this.customersService.getFileInline( fileId ).subscribe(
      result => {

        const disposition = result.headers.get('Content-Disposition');
        const contentType = result.headers.get('Content-Type');
        const filename = disposition.split(';')[1].trim().split('=')[1];

        const blob = new Blob([result.body], { type: contentType });
        //FileSaver.saveAs(blob , filename);
        const fileURL = URL.createObjectURL(blob);


        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        if( contentType.indexOf('image') >= 0){
          this.isImgHidden = false;
          this.isFrameHidden = true;

        }else{
          this.isImgHidden = true;
          this.isFrameHidden = false;

        }
        this.errorMsg = null;
        this.filename = filename;





        //FileHelper.saveFile( result );
      },
      err =>{
        this.filename = null;
        this.isImgHidden = true;
        this.isFrameHidden = true;
        this.errorMsg = 'Error occured during downloading the file.';

        this._toastService.error( err.error.message || err.message || err.error || err);
      }

    );
  }


  approve() {
    this.dialog.open(ConfirmDialogComponent, {
      data:{
        title: 'Approve',
        text:'Are you sure you want to approve this application and create a user?',
        confirm: 'Yes',
        cancel: 'No'
      },
    }).afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.isLoading = true;
        this.partnerWalletService.approveInvite(this.inviteId).subscribe( invite => {
            this.isLoading = false;
            this.loadData();
          }
        );
      }
    });
  }

  declineWithReason() {
    this.dialog.open(ConfirmDialogComponent, {
      data:{
        title: 'Approve',
        text:'Are you sure you want to decline this application and delete it?',
        confirm: 'Yes',
        cancel: 'No'
      },
    }).afterClosed().subscribe(result => {
      if (result == 'ok') {
        this.isLoading = true;
        this.partnerWalletService.declineInviteWithReason(this.inviteId, 'declined').subscribe( invite => {
            this.isLoading = false;
            this.loadData();
          }
        );
      }
    });
  }


}
